import { Focusable, Tooltip } from '@cfa/react-core';

import { cn } from '@/utils/tailwind';

interface ActionIconProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ComponentType<{ size?: number }>;
  tooltip?: string;
}

const ActionIcon: React.FC<ActionIconProps> = ({
  children,
  icon: Icon,
  tooltip,
  ...props
}) => (
  <Tooltip.Root delay={100} closeDelay={50}>
    <Focusable>
      <button
        type="button"
        {...props}
        className={cn(
          'hover:bg-grayscale-gray2/50 cursor-pointer rounded-sm p-1.5! transition-colors',
          props.className,
        )}
      >
        <Icon size={18} />
        {children}
      </button>
    </Focusable>
    <Tooltip.Content
      placement="bottom"
      className="text-variant-caption1! p-1.5!"
    >
      {tooltip}
    </Tooltip.Content>
  </Tooltip.Root>
);

export default ActionIcon;
